/** Dash placeholder for empty table cells. Defined here (outside the component tree) to avoid circular imports. */
export const emptyCellDash = "-";
